export default [
  //系列列表(类型)
  {
    path: "/:lang/EBook/SeriesListLX",
    name: "SeriesListLX",
    alias: [
      "/:lang/EBook/SeriesListLX",
      "/:lang/EBook/SeriesListLX",
      "/:lang/EBook/SeriesListLX",
      "/:lang/EBook/SeriesListLX",
      "/:lang/EBook/SeriesListLX",
    ],
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/SeriesListLX.vue"),
  },
  //按字母
  {
    path: "/:lang/EBook/SeriesListZM",
    name: "SeriesListZM",
    alias: [
      "/:lang/EBook/SeriesListZM",
      "/:lang/EBook/SeriesListZM",
      "/:lang/EBook/SeriesListZM",
      "/:lang/EBook/SeriesListZM",
      "/:lang/EBook/SeriesListZM",
    ],
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: true,
    },
    component: () => import("/@/views/EBook/SeriesListZM.vue"),
  },
  //产品搜索
  {
    path: "/:lang/EBook/searchProduct",
    name: "searchProduct",
    alias: [
      "/:lang/EBook/searchProduct",
      "/:lang/EBook/searchProduct",
      "/:lang/EBook/searchProduct",
      "/:lang/EBook/searchProduct",
      "/:lang/EBook/searchProduct",
    ],
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/searchProduct.vue"),
  },
  // 选型列表(介质)
  {
    path: "/:lang/XPump/SelSeriesListJZ2",
    name: "SelSeriesListJZ2",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/XPump/SelSeriesListJZ2.vue"),
  },
  // 介质列表2（通用）
  {
    path: "/:lang/EBook/SeriesListJZ2",
    name: "SeriesListJZ",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/SeriesListJZ2.vue"),
  },
  // 介质列表3（通用）
  {
    path: "/:lang/EBook/SeriesListJZ3",
    name: "SeriesListJZ3",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/SeriesListJZ3.vue"),
  },

  // 选型列表(泵型)
  {
    path: "/:lang/XPump/SelSeriesListBX",
    name: "SelSeriesListBX3",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/XPump/SelSeriesListByBX.vue"),
  },
  // 选型参数
  {
    path: "/:lang/XPump/SelParas/Index",
    name: "SeriesParas",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/XPump/SelParas.vue"),
  },
  //泵型列表
  {
    path: "/:lang/EBook/ApplicationBengXing",
    name: "ApplicationBengXingMain",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/ApplicationBengXing/main.vue"),
  },
  //泵型系列列表
  {
    path: "/:lang/EBook/SeriesListBX",
    name: "SeriesListBX",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/SeriesListBX/main.vue"),
  },
  //   行业沙盘
  {
    path: "/:lang/EBook/SandTable",
    name: "SandTable",
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/SandTable.vue"),
  },
  // 样本橱窗界面
  {
    path: "/:lang/EBooK/PDFShowCase",
    name: "PDFShowCase",
    alias: [
      "/:lang/EBook/PDFShowCase",
      "/:lang/EBook/PDFShowCase",
      "/:lang/EBook/PDFShowCase",
      "/:lang/EBook/PDFShowCase",
      "/:lang/EBook/PDFShowCase",
    ],
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: false,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/PDFShowCase.vue"),
  },
  //行业列表
  {
    path: "/:lang/EBook/ApplicationHangYeMain",
    name: "ApplicationHangYeMain",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/ApplicationHangYe/main.vue"),
  },
  // 系列列表(行业)
  {
    path: "/:lang/EBook/SeriesListHY",
    name: "SeriesListHY",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/EBook/SeriesListHY.vue"),
  },
  {
    path: "/:lang/Series/index/:id",
    name: "SeriesDetailIndex",
    meta: {
      title: "",
      cache: false,
      noFrame: false,
      modulsName: "ebook",
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Series/index.vue"),
  }
];
